import React from 'react'

import View from '../../../../../components/pdf/View'
import { Table, TableHead, TableRow } from '../../../../../components/pdf/Table'
import Text from '../../../../../components/pdf/Text'
import Image from '../../../../../components/pdf/Image'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'
import {
  sameTypeDevices,
  filterSameTypeDevices,
  findReplyByQuestionId,
  getDeviceFields,
  getFieldValue,
  getReplyValue,
  mainDeviceAsFirst
} from '../../_helpers/pdfHelpers'
import { useDevicesFieldValues } from '../../_load/DevicesFieldValuesLoader'
import Grid, { Col } from '../../../../../components/pdf/Grid'
import Separator from '../../../../../components/pdf/Separator'

export const VivoText = ({ children, style, ...props }) => (
  <Text style={{ ...style, fontFamily: 'vivo_typelight' }} {...props}>
    {children}
  </Text>
)

const Devices = () => {
  const serviceOrder = useServiceOrder()
  const allDevices = useDevicesFieldValues()
  const isManualComparison = getReplyValue(findReplyByQuestionId(serviceOrder.replies, 599))
  const columns = [0, 1]
  const mainDeviceReply = findReplyByQuestionId(serviceOrder.replies, 598)
  const mainDevice = allDevices.find(asset => asset.id === mainDeviceReply.value.id)
  const mainDeviceType = mainDevice.placeLevelsResume.find(level => level.levelId === 31).name.toLowerCase()
  const rows = ['', ...getDeviceFields(mainDeviceType)]
  let relevantDevices = isManualComparison ? allDevices : [mainDevice]

  const findNearesPriceDevice = (devicesToIgnore, devices, mainDevicePrice) => {
    let nearestPriceDevice
    devices.forEach(device => {
      const devicePrice = getFieldValue('Preço em 24x', device.fieldValues)

      if (!devicesToIgnore.includes(device.id) && devicePrice <= mainDevicePrice) {
        if (!nearestPriceDevice) {
          nearestPriceDevice = device
        } else {
          const nearestPrice = getFieldValue('Preço em 24x', nearestPriceDevice.fieldValues)

          if (devicePrice <= mainDevicePrice && devicePrice > nearestPrice) {
            nearestPriceDevice = device
          }
        }
      }
    })

    return nearestPriceDevice
  }

  const genDevicesData = () => {
    if (!isManualComparison) {
      const mainDevicePrice = getFieldValue('Preço em 24x', mainDevice.fieldValues)

      const filteredDevices = filterSameTypeDevices(mainDeviceType, allDevices)

      let nearestPriceDevice = findNearesPriceDevice([mainDevice.id], filteredDevices, mainDevicePrice)

      if (nearestPriceDevice) relevantDevices.push(nearestPriceDevice)
    }

    const devicesData = relevantDevices.map(device => {
      const fields = getDeviceFields(mainDeviceType)
      const deviceData = {
        img: getFieldValue('FOTO (URL)', device.fieldValues),
        isMainDevice: device.id === mainDevice.id
      }

      fields.forEach(field => {
        if (field === 'Nome') {
          deviceData['Nome'] = device.name
        } else {
          deviceData[field] = getFieldValue(field, device.fieldValues)
        }
      })

      return deviceData
    })
    return mainDeviceAsFirst(devicesData)
  }

  const devices = genDevicesData()

  if (!isManualComparison && !mainDevice) {
    return (
      <View pageBreakAfter>
        <VivoText bold align={'center'}>
          {'É necessário selecionar um aparelho para fazer um comparativo automático'}
        </VivoText>
      </View>
    )
  }

  if (isManualComparison && relevantDevices.length < 2) {
    return (
      <View pageBreakAfter>
        <VivoText bold align={'center'}>
          {'É necessário selecionar dois aparelhos para fazer o comparativo manual.'}
        </VivoText>
      </View>
    )
  }

  if (!isManualComparison && relevantDevices.length < 2) {
    return (
      <View pageBreakAfter>
        <VivoText bold align={'center'}>
          {'Dispositivo compatível não localizado'}
        </VivoText>
      </View>
    )
  }

  if (isManualComparison && !sameTypeDevices(relevantDevices[0], relevantDevices[1])) {
    return (
      <View pageBreakAfter>
        <VivoText bold align={'center'}>
          {'Comparação entre tipos diferentes não suportada.'}
        </VivoText>
      </View>
    )
  }

  const mountDeviceImages = () => {
    const images = []
    if (isManualComparison) {
      devices[0] &&
        images.push(
          <TableHead align="center" style={{ border: `solid 1px white` }}>
            <Image src={devices[0]['img']} maxWidth={120} />
          </TableHead>
        )
      devices[1] &&
        images.push(
          <TableHead align="center" style={{ border: `solid 1px white` }}>
            <Image src={devices[1]['img']} maxWidth={120} />
          </TableHead>
        )
    } else {
      devices[0] &&
        images.push(
          <TableHead align="center" style={{ border: `solid 1px white` }}>
            <Image src={devices[0]['img']} maxWidth={120} />
          </TableHead>
        )
      devices[1] &&
        images.push(
          <TableHead align="center" style={{ border: `solid 1px white` }}>
            <Image src={devices[1]['img']} maxWidth={120} />
          </TableHead>
        )
      devices[2] &&
        images.push(
          <TableHead align="center" style={{ border: `solid 1px white` }}>
            <Image src={devices[2]['img']} maxWidth={120} />
          </TableHead>
        )
    }

    return images
  }

  return (
    <View pageBreakAfter>
      <div
        style={{
          paddingLeft: '10px',
          paddingRight: '10px'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'end' }}>
          <Image src={'/pdfs/vivo/vivo_empresa.png'} maxWidth={120} />
        </div>
        <Separator weight={5} />
        <Grid justify={'end'}>
          <Col></Col>
          <Col></Col>
        </Grid>
        <Separator weight={10} />

        <Table style={{ width: '100%' }}>
          <TableRow style={{ border: `solid 1px white` }}>
            <td />
            <td
              style={{
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center'
              }}
            >
              <div
                style={{
                  height: '30px',
                  width: '80%',
                  backgroundColor: '#6E2383',
                  border: `solid 1px white`,
                  borderRadius: 5,
                  alignContent: 'center',
                  justifyContent: 'center'
                }}
              >
                <VivoText align={'center'} color={'white'}>
                  {'Modelo Contratado'}
                </VivoText>
              </div>
            </td>
            <td>
              <div
                style={{
                  height: '30px',
                  backgroundColor: '#82D400',
                  border: `solid 1px white`,
                  borderRadius: 5,
                  alignContent: 'center'
                }}
              >
                <VivoText align={'center'} color={'white'}>
                  {'Modelo Disponível para Troca'}
                </VivoText>
              </div>
            </td>
          </TableRow>
          <TableRow style={{ border: `solid 1px white` }} />
          <TableHead align="center" style={{ border: `solid 1px white` }} />
          {mountDeviceImages()}
          {rows.map((linha, i) => {
            if (i === 0) return false
            return (
              <TableRow key={i}>
                {i === 1 && (
                  <td bgColor={'#EB3C7D'} style={{ border: `solid 1px white`, borderLeft: `solid 1px white` }}>
                    <VivoText color={'white'} align={'center'}>
                      {linha.toUpperCase()}
                    </VivoText>
                  </td>
                )}

                {i > 1 && (
                  <td
                    style={{
                      paddingLeft: '10px',
                      backgroundColor: i % 2 === 0 ? '#CCD2D8' : '#E7EAEC',
                      border: `solid 1px white`,
                      borderLeft: `solid 1px white`
                    }}
                  >
                    <VivoText bold color={'black'}>
                      {linha}
                    </VivoText>
                  </td>
                )}

                {columns.map(coluna => {
                  if (devices[coluna][linha] === 'V') {
                    return (
                      <td
                        key={`${devices[coluna][linha]}`}
                        style={{
                          backgroundColor: i % 2 === 0 ? '#CCD2D8' : '#E7EAEC',
                          border: `solid 1px white`
                        }}
                      >
                        <VivoText align={'center'} bold color={'#00b050'}>
                          {'SIM'}
                        </VivoText>
                      </td>
                    )
                  }
                  if (devices[coluna][linha] === 'X') {
                    return (
                      <td
                        key={`${devices[coluna][linha]}`}
                        style={{
                          backgroundColor: i % 2 === 0 ? '#CCD2D8' : '#E7EAEC',
                          border: `solid 1px white`
                        }}
                      >
                        <VivoText align={'center'} bold color={'#ff0000'}>
                          {'NÃO'}
                        </VivoText>
                      </td>
                    )
                  }
                  if (linha === 'Nome') {
                    return (
                      <td
                        key={`${devices[coluna][linha]}`}
                        style={{
                          backgroundColor: coluna === 0 ? '#6E2383' : '#82D400',
                          border: `solid 1px white`
                        }}
                      >
                        <VivoText align={'center'} color={'white'}>
                          {devices[coluna][linha]}
                        </VivoText>
                      </td>
                    )
                  }
                  return (
                    <td
                      key={`${devices[coluna][linha]}`}
                      style={{
                        backgroundColor: i % 2 === 0 ? '#CCD2D8' : '#E7EAEC',
                        border: `solid 1px white`,
                        borderLeft: `solid 1px white`
                      }}
                    >
                      <VivoText align={'center'}>{devices[coluna][linha]}</VivoText>
                    </td>
                  )
                })}
              </TableRow>
            )
          })}
        </Table>
      </div>
    </View>
  )
}

export default Devices
